/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const DEFAULT_VEHICLE_TYPE = 'VEHICLETYPE_PASSENGER_CAR' as const;
